import React, { useEffect, useState } from "react";
import backend from "../../../../../api";
import { useSelector } from "react-redux";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { Card, CardActions, CardContent, CardHeader } from "@material-ui/core";
import { formatPrice } from "../../../../../utils/formatPrice";

const EarningAnalytics = () => {
  const [analytics, setAnalytics] = useState([]);
  const [period, setPeriod] = useState("today");
  const { user } = useSelector((state) => state.auth);

  const handlePeriodChange = (e) => {
    setPeriod(e.target.value);
  };

  const getAnalytics = async (selectedPeriod) => {
    try {
      const response = await backend.get(
        `/userwallet/analytics/${selectedPeriod}`,
        {
          params: { userId: user.user._id, active: true, order_pos: false },
        }
      );
      console.log("response: ", response);
      const chartData = response?.data?.chartData?.map((item) => ({
        name: item.date,
        earnings: item.earnings,
      }));
      setAnalytics(chartData);
    } catch (error) {
      console.error("error: ", error);
    }
  };

  const formatXAxis = (tickItem) => {
    if (period === "today") {
      return `${tickItem}`;
    } else if (period === "weekly") {
      const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      return days[tickItem - 1];
    } else if (period === "monthly") {
      return `${tickItem}`;
    } else if (period === "yearly") {
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      return months[tickItem - 1];
    }
    return tickItem;
  };

  const formatYAxis = (tickItem) => {
    return `$${tickItem}`;
  };

  const formatTooltip = (value) => {
    return `$${value}`;
  };

  useEffect(() => {
    getAnalytics(period);
  }, [period]);
  return (
    <Card>
      <CardHeader title="Earning Analytics" />
      <CardActions>
        <div className="d-flex justify-content-between w-100">
          <select
            value={period}
            onChange={handlePeriodChange}
            className="form-control"
          >
            <option value="today">Today</option>
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
            <option value="yearly">Yearly</option>
          </select>
        </div>
      </CardActions>
      <CardContent>
        <div className="box">
          <div className="box-title d-flex justify-content-between">
            <h3>Total Earnings ({period})</h3>
            <div className="welcome-msg text-muted">
            <h4>
  {analytics.length > 0
    ? formatPrice(analytics.reduce((acc, cur) => acc + cur.earnings, 0))
    : formatPrice(0)}{" "}
</h4>
            </div>
          </div>
          <div className="box-content py-3">
            <ResponsiveContainer width="100%" height={300}>
              <LineChart
                data={analytics}
                margin={{ top: 5, right: 20, bottom: 5, left: 0 }}
              >
                <defs>
                  <linearGradient
                    id="colorEarnings"
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="1"
                  >
                    <stop offset="5%" stopColor="#ff4c3b" stopOpacity={0.8} />
                    <stop offset="95%" stopColor="#ff4c3b" stopOpacity={0} />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke="#ccc" />
                <XAxis dataKey="name" tickFormatter={formatXAxis} />
                <YAxis tickFormatter={formatYAxis} />
                <Tooltip
                  formatter={formatTooltip}
                  contentStyle={{
                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                    borderRadius: "10px",
                  }}
                  itemStyle={{ color: "#ff4c3b" }}
                />
                <Legend verticalAlign="top" align="right" />
                <Line
                  type="monotone"
                  dataKey="earnings"
                  stroke="#ff4c3b"
                  fillOpacity={1}
                  fill="url(#colorEarnings)"
                  strokeWidth={2}
                  dot={{
                    r: 5,
                    stroke: "#ff4c3b",
                    strokeWidth: 2,
                    fill: "white",
                  }}
                  activeDot={{ r: 8 }}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default EarningAnalytics;
